import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
// import { getGlobal, setGlobal } from 'reactn';

import QuizBackground from "./background";
import QuizReady from "./ready";
import ScoreBoard from "./scoreboard";
// import Menu from "./menu";
import SelectQuiz from "./select";
import QuizContent from "./content";
import QRCode from "./qrcode";
import Answer from "./answer";
// import Loader from "./loader";
// import usePreloader from './usePreloader';
import {
  CHAMPION_QUIZZES,
  MASTER_QUIZZES,
  WINNER_QUIZZES,
} from "../../constants";

// setGlobal({
//   images: {},
//   videos: {},
//   downloadCount: 0,
//   totalCount: 0
// });

const Home = () => {
  // const [preloaded] = usePreloader();
  const [quizMode, setQuizMode] = useState(0);
  const [quizStep, setQuizStep] = useState(0);
  const [isReady, setReady] = useState(false);
  const [inProgress, setInProgress] = useState(false);
  const [showQuiz, setShowQuiz] = useState(false);
  const [showScore, setShowScore] = useState(false);
  const [showQRCode, setShowQRCode] = useState(false);
  const [showAnswer, setShowAnswer] = useState(false);
  const [quizzes, setQuizzes] = useState([]);
  const [score, setScore] = useState(0);
  const [totalAnswersRight, setTotalAnswersRight] = useState(0);

  useEffect(() => {
    if (showQuiz) {
      if (window.timeoutID) clearTimeout(window.timeoutID);
      window.timeoutID = setTimeout(() => {
        // if (inProgress)
        exitQuiz();
      }, 300000);
    } else {
      clearTimeout(window.timeoutID);
    }
  }, [showQuiz]);

  const prepareQuiz = (mode) => {
    exitQuiz();
    setQuizMode(mode);
    setReady(true);
    setInProgress(true);
    setQuizStep(0);

    switch (mode) {
      case 0:
        setQuizzes(CHAMPION_QUIZZES);
        break;
      case 1:
        setQuizzes(MASTER_QUIZZES);
        break;
      case 2:
        setQuizzes(WINNER_QUIZZES);
        break;
      default:
        break;
    }
  };

  const startQuiz = () => {
    setReady(false);
    setShowQuiz(true);
  };

  const resumeQuiz = () => {
    if (quizStep < 9) {
      setQuizStep(quizStep + 1);
      setShowQuiz(true);
    } else {
      setShowScore(true);
      setShowQuiz(false);
    }

    setShowAnswer(false);
  };

  const selectAnswer = (answer, point) => {
    setShowQuiz(false);
    setShowAnswer(true);

    setScore(score + point);
    if (String(quizzes[quizStep].answer) === String(answer))
      setTotalAnswersRight(totalAnswersRight + 1);
  };

  const handleChallengeFriend = () => {
    // setShowQRCode(true);
    // setShowScore(false);
    window.location.href = "/utmana";
  };

  const showScoreBoard = () => {
    setShowScore(true);
    setShowQRCode(false);
  };

  const exitQuiz = () => {
    setInProgress(false);
    setShowScore(false);
    setShowQRCode(false);
    setShowQuiz(false);
    setReady(false);
    setShowAnswer(false);
    setQuizStep(0);
    setQuizMode(0);
    setQuizzes([]);
    setTotalAnswersRight(0);
    setScore(0);
  };

  // if (!preloaded)
  // return (<Loader/>)

  return (
    <QuizBackground>
      {/* <Box
        sx={{
          height: "50px",
          width: "100%",
          background: `#004f9f url('/atg_banner1_2x.png') no-repeat 50%`,
          backgroundSize: "cover",
          textAlign: "center",
          justifyContent: "center",
        }}
      /> */}
      {inProgress && showQuiz && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <img
            src={`/timeline.gif?time=${Date.now()}`}
            style={{
              height: "8px",
              width: "100%",
            }}
          />
          <QuizContent
            quiz={quizzes && quizzes[quizStep]}
            selectAnswer={selectAnswer}
            quizStep={quizStep}
            quizMode={quizMode}
            exitQuiz={exitQuiz}
            inProgress={inProgress}
          />
        </Box>
      )}

      <Box
        sx={{
          marginLeft: { xs: 3, md: 0 },
          marginRight: { xs: 3, md: 0 },
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          height: "inherit",
        }}
      >
        {isReady && <QuizReady handleContinue={startQuiz} />}
        {!inProgress && <SelectQuiz prepareQuiz={prepareQuiz} />}

        {inProgress && showScore && (
          <ScoreBoard
            score={score}
            totalAnswersRight={totalAnswersRight}
            handleChallengeFriend={handleChallengeFriend}
            handleSelectQuiz={exitQuiz}
            handleStartPage={exitQuiz}
          />
        )}
        {inProgress && showAnswer && (
          <Answer
            answer={quizzes[quizStep].answer}
            quiz={quizzes[quizStep]}
            handleContinue={resumeQuiz}
          />
        )}
        {inProgress && showQRCode && <QRCode handleBack={showScoreBoard} />}
      </Box>

      {/* <Menu handleClickMenu={exitQuiz} prepareQuiz={prepareQuiz}/> */}
    </QuizBackground>
  );
};

export default Home;
